import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper';
import EFPicture from '@elem/compCommon/EFPicture';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

let sceneTextEnterNA1: any = null,
    sceneTextLeaveNA1: any = null;
export default function NA1() {
    const { useLang, useRouter, useEffect, useState, gtm, Link } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('delta_pro_ultra.launch.detail');
    const [textEnter, setTextEnter] = useState(false);
    const [gap, setGap] = useState(24);

    const cards: any[] = [
        {
            img: '/responsive/picture/delta-pro-ultra/launch/24_1',
            avatar: '/responsive/picture/delta-pro-ultra/launch/24_1_avatar.jpg',
            text: t('secNA1_card1_text'),
            author: t('secNA1_card1_author'),
        },
        {
            img: '/responsive/picture/delta-pro-ultra/launch/24_2',
            avatar: '/responsive/picture/delta-pro-ultra/launch/24_2_avatar.jpg',
            text: t('secNA1_card2_text'),
            author: t('secNA1_card2_author'),
        },
        {
            img: '/responsive/picture/delta-pro-ultra/launch/24_3',
            avatar: '/responsive/picture/delta-pro-ultra/launch/24_3_avatar.jpg',
            text: t('secNA1_card3_text'),
            author: t('secNA1_card3_author'),
        },
    ];

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const resize = () => setGap(window?.innerWidth > 1440 ? 24 : window?.innerWidth > 1024 ? 20 : 16);
            resize();
        }
    }, []);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const resizeAni = () => {
                if (sceneTextEnterNA1) {
                    AniContainer.removeScene(sceneTextEnterNA1);
                    sceneTextEnterNA1 = null;
                }
                if (sceneTextLeaveNA1) {
                    AniContainer.removeScene(sceneTextLeaveNA1);
                    sceneTextLeaveNA1 = null;
                }

                const clientH = (window.innerHeight || 0) * 0.2;
                const startH = Math.min(clientH, 150);
                sceneTextEnterNA1 = AniContainer.create({
                    triggerElement: '.dpu-detail-NA1',
                    triggerHook: 1,
                    offset: startH, //textTarget?.offsetHeight,
                    duration: 200, //textTarget?.offsetHeight / 2,
                    onEnter: () => setTextEnter(true),
                    //onLeave: () => setTextEnter(false),
                });
            };
            resizeAni();
            return () => {
                if (sceneTextEnterNA1) {
                    AniContainer.removeScene(sceneTextEnterNA1);
                    sceneTextEnterNA1 = null;
                }
                if (sceneTextLeaveNA1) {
                    AniContainer.removeScene(sceneTextLeaveNA1);
                    sceneTextLeaveNA1 = null;
                }
            };
        }
    }, []);

    return (
        <section className={`dpu-detail-NA1 dpu-detail-section ${css['dpu-detail-NA1']}`}>
            <div className={`text-info ${textEnter ? 'enter' : ''}`}>
                <h2 className="title">{t('secNA1_title')}</h2>
            </div>
            <Swiper className="cards swiper-box" modules={[Pagination]} spaceBetween={gap} slidesPerView={'auto'} initialSlide={0} pagination={true}>
                {cards?.map((card: any, k: number) => (
                    <SwiperSlide className={`swiper-item item-${k + 1}`} key={k}>
                        <div className="img-box">
                            <EFPicture src={`${card?.img}.jpg`} srcPad={`${card?.img}_768.jpg`} srcMobile={`${card?.img}_768.jpg`} alt={card?.text} />
                            <p className={`card-text ${k === 1 ? 'black' : ''}`}>{card?.text}</p>
                        </div>
                        <div className="auth-info">
                            <div className="auth-avatar">
                                <EFPicture src={`${card?.avatar}`} alt={card?.author} />
                            </div>
                            <p className="auth-text">{card?.author}</p>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
        </section>
    );
}
